// require('dotenv').config();
let environment = 'https://story4u-node-temp.onrender.com';
// let environment = 'http://localhost:8080';

// Domain configuration - can be overridden with environment variables
const DOMAIN = process.env.REACT_APP_DOMAIN || 'https://badeladham.in';
const DOMAIN_NAME = process.env.REACT_APP_DOMAIN_NAME || 'badeladham.in';

module.exports  = {
    API_URL: `${environment}`,
    GIF_Id: '5ff5f2bba65c8f9764485dca',
    DOMAIN: DOMAIN,
    DOMAIN_NAME: DOMAIN_NAME
}



// WEBPACK FOOTER //
// ./src/config.js